/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Different_QuestionInputs */

const en_faq_different_question = /** @type {(inputs: Faq_Different_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is this different from buying another AI tool?`)
};

const lv_faq_different_question = /** @type {(inputs: Faq_Different_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar ko tas atšķiras no kārtējā AI rīka iegādes?`)
};

/**
* | output |
* | --- |
* | "How is this different from buying another AI tool?" |
*
* @param {Faq_Different_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_different_question = /** @type {((inputs?: Faq_Different_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Different_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_different_question(inputs)
	return en_faq_different_question(inputs)
});